import axios from "axios"
import { useCallback } from "react"
import { useIntl } from "react-intl"
import type { FinancingNotification } from "./FinancingNotification"
import { financingMessages } from "./financingMessages"

export function useFinancingNotificationResolver() {
	const { formatMessage } = useIntl()
	return useCallback(
		(error: unknown): FinancingNotification => {
			const messages = findMessages(error)

			return {
				severity: messages.severity,
				text: formatMessage(messages.text),
				title: formatMessage(messages.title),
			}
		},
		[formatMessage],
	)
}

function findMessages(error: unknown) {
	if (!axios.isAxiosError(error) || !error.response) {
		return financingMessages.errors.generic
	}

	const status = error.response.status
	return status === 401
		? financingMessages.errors.unauthorized
		: status === 504
			? financingMessages.errors.timeout
			: financingMessages.errors.generic
}
